<template>
  <div>
    <v-layout mt-2 row :column="$vuetify.breakpoint.mdOnly" wrap>
      <v-flex xs12 sm12 md12 lg12 xl5>
        <div :class="$vuetify.breakpoint.lgAndUp ? 'ml-4' : ''">
          <o-small-title>{{$t('reservas.scoring.ingresosNetos')}}</o-small-title>
          <slide-y-list group tag="div" style="position:relative;">
            <v-layout row wrap v-for="(ingreso, i) in comprador.ingresos" :key="'ingreso' + ingreso.id_temporal">
              <v-icon v-if="$vuetify.breakpoint.mdAndUp" color="primary" class="custom-icon" style="font-size:8px">icon-circle</v-icon>
              <v-flex xs12 md3 lg2 xl3 :class="$vuetify.breakpoint.smAndDown ? '' : 'pl-3'">
                <v-select
                  :label="$t('reservas.scoring.concepto')"
                  :items="conceptos"
                  item-text="nombre"
                  item-value="tipo"
                  :name="'ingreso[' + indice + ']concepto[' + i + ']'"
                  :rules="[rules.required]"
                  v-model="ingreso.concepto"
                />
              </v-flex>
              <v-flex  xs12 md2 lg2 xl2 :class="$vuetify.breakpoint.smAndDown ? '' : 'pl-3'">
                <o-numeric-text-field
                  :label="$t('reservas.scoring.cantidad')"
                  :name="'ingreso[' + indice + ']valor[' + i + ']'"
                  v-model="ingreso.valor"
                  :rulesProps="[rules.required, rules.mayor(0), rules.menor(Math.pow(10, 10))]"
                  suffix="€"
                />
              </v-flex>
              <v-flex xs12 md2 lg2 xl2 :class="$vuetify.breakpoint.smAndDown ? '' : 'pl-3'">
                <v-select
                    :label="$t('reservas.scoring.numPagas')"
                    :items="itemsPagas"
                    :name="'ingreso[' + indice + ']pagas[' + i + ']'"
                    v-model="ingreso.pagas"
                    :rules="[rules.required]"
                />
              </v-flex>
              <v-flex xs12 md3 lg3 xl3 :class="$vuetify.breakpoint.smAndDown ? '' : 'pl-3'">
                <v-select
                  :label="$t('reservas.scoring.tipo')"
                  :items="tiposIngresos"
                  item-text="nombre"
                  item-value="tipo"
                  :name="'ingreso[' + indice + ']tipo[' + i + ']'"
                  :rules="[rules.required]"
                  v-model="ingreso.tipo"
                />
              </v-flex>
              <v-flex xs1 md1 lg1>
                <v-btn
                  :class="[$vuetify.breakpoint.mdOnly ? 'pl-5' : '', $vuetify.breakpoint.xsOnly ? 'mt-0' : '']"
                  icon
                  class="mb-0 mt-3"
                  @click="borrarIngreso(i)"
                >
                <v-icon medium color="primary">remove_circle_outline</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout key="add_button">
                <v-btn
                  style="margin-left:0"
                  :class="[$vuetify.breakpoint.mdOnly ? 'mb-4' : '', $vuetify.breakpoint.xsOnly ? 'ml-4 mb-4' : '', $vuetify.breakpoint.smOnly ? 'ml-4 mb-4' : '']"
                  flat
                  @click="addIngreso"
                >
                  <v-icon style="padding-right:10px" medium color="primary">add_circle_outline</v-icon>
                  <span class="primary--text">{{$t('reservas.scoring.addIngreso')}}</span>
                </v-btn>
            </v-layout> 
          </slide-y-list>
        </div>
      </v-flex>


      <v-divider v-if="$vuetify.breakpoint.xlOnly" absolute vertical></v-divider>

      <v-flex xs12 lg12 xl6>
        <div :class="$vuetify.breakpoint.lgAndUp ? 'ml-4' : ''">
          <o-small-title>{{$t('reservas.scoring.gastos')}}</o-small-title>
          <slide-y-list group tag="div" style="position:relative;">
            <v-layout row wrap v-for="(gasto, i) in comprador.gastos" :key="'gasto' + gasto.id_temporal" style="width:100%;">
              <v-icon v-if="$vuetify.breakpoint.mdAndUp" color="primary" class="custom-icon" style="font-size:8px">icon-circle</v-icon>
              <v-flex xs12 md5 lg3 xl4 :class="$vuetify.breakpoint.smAndDown ? '' : 'pr-2 pl-3'">
                <v-select
                  :items="tiposGasto"
                  :label="$t('reservas.scoring.tipo')"
                  item-text="nombre"
                  item-value="tipo"
                  :name="'gastos[' + indice + ']tipo[' + i + ']'"
                  v-model="gasto.tipo"
                  :rules="[rules.required]"
                />
              </v-flex>
              <v-flex xs12 md5 lg4 xl3 :class="[$vuetify.breakpoint.mdAndUp ? 'pl-2 pr-2' : '']">
                <o-numeric-text-field
                  :label="$t('reservas.scoring.cantidad')"
                  :name="'gastos[' + indice + ']valor[' + i + ']'"
                  v-model="gasto.valor"
                  :rulesProps="[rules.required, rules.mayor(0), rules.menor(Math.pow(10, 10))]"
                  suffix="€"
                />
              </v-flex>
              <v-flex xs1 md1 lg1>
                <v-btn
                  :class="$vuetify.breakpoint.mdOnly ? 'pl-5' : ''"
                  icon
                  class="mb-0 mt-3"
                  @click="borrarGasto(i)"
                >
                  <v-icon medium color="primary">remove_circle_outline</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout key="add_gasto">
              <v-btn
                @click="addGasto"
                flat
                :class="$vuetify.breakpoint.mdOnly ? 'ml-0' : ''"
                style="margin-left:24px"
              >
                <v-icon style="padding-right:10px" medium color="primary">add_circle_outline</v-icon>
                <span class="primary--text">{{$t('reservas.scoring.addGasto')}}</span>
              </v-btn>
            </v-layout>
          </slide-y-list>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import rules from '@/mixins/rules'
import MixinComprador from '@/mixins/comprador'
import uniqid from 'uniqid'

export default {
  mixins: [rules, MixinComprador],
  props: {
    comprador: {
      type: Object,
      required: true
    },
    indice: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      itemsPagas: []
    }
  },
  created () {
    for (let i = 1; i <= 14; i++) {
      this.itemsPagas.push(i.toString())
    }
  },
  components: {
  },
  computed: {
    ...mapGetters({
    }),
    conceptos() {
      return [
        { nombre: this.$t('reservas.scoring.nomina'), tipo: 'nomina' },
        { nombre: this.$t('reservas.scoring.rentas'), tipo: 'rentas' },
        { nombre: this.$t('reservas.scoring.pension'), tipo: 'pension' },
        { nombre: this.$t('reservas.scoring.otros'), tipo: 'otros' }
      ]
    },
    tiposIngresos () {
      return [
        { nombre: this.$t('reservas.scoring.cuentaAjena'), tipo: 'cuentaAjena' },
        { nombre: this.$t('reservas.scoring.cuentaPropia'), tipo: 'cuentaPropia' },
        { nombre: this.$t('reservas.scoring.pensionista'), tipo: 'pensionista' }
      ]
    },
    tiposGasto () {
      return [
        { nombre: this.$t('reservas.scoring.prestamo'), tipo: 'prestamo' },
        { nombre: this.$t('reservas.scoring.hipoteca'), tipo: 'hipoteca' },
        { nombre: this.$t('reservas.scoring.pensionATerceros'), tipo: 'pension' },
        { nombre: this.$t('reservas.scoring.otrosGastos'), tipo: 'otros' }
      ]
    }
  },
  methods: {
    ...mapActions({
    }),
    addIngreso () {
      this.comprador.ingresos.push({
        concepto: null,
        tipo: null,
        valor: null,
        pagas: null,
        id_temporal: uniqid()
      })
    },
    borrarIngreso (index) {
      this.comprador.ingresos.splice(index, 1)
    },
    addGasto () {
      this.comprador.gastos.push({
        tipo: null,
        valor: null,
        id_temporal: uniqid()
      })
    },
    borrarGasto (index) {
      this.comprador.gastos.splice(index, 1)
    }
  }
}
</script>

<style lang="stylus" scoped>

.slide-y-transition-move
  transition transform 0.3s

@require '~vuetify/src/stylus/settings/_colors'

.v-btn:hover:before {
      background-color: transparent;
    }

.fullWidth.v-input--selection-controls .v-input__control
  width: 100% !important

.section
  border-radius: 3px;
  border-style: solid;

.section-validado
  background-color: $green["lighten-5"] !important;
  border-color: $green["lighten-4"] !important;

.section-rechazado
  background-color: $red["lighten-5"] !important;
  border-color: $red["lighten-4"] !important;

@media (max-width: 600px)
  .buttonResponsive
    margin-left:15px

</style>


// WEBPACK FOOTER //
// src/components/reservas/scoring/FormularioCompradorScoring.vue